import { makeAutoObservable } from "mobx";
import { CachedItem } from "@lib-shared/lib";
import { Key } from "core/constants";

class FreshDeskStore {
    static cache = new CachedItem(Key.freshDeskContact);

    contact: any;

    constructor() {
        this.contact = FreshDeskStore.cache.value;

        makeAutoObservable(this);
    }

    updateContact(value: any) {
        this.contact = value;
        FreshDeskStore.cache.set(value);
    }
}

export default FreshDeskStore;
